import type { StatusGroupRes } from 'api/swagger';
import { findWarehouseById } from 'shared/utils/warehouses/find-warehouse-by-id.ts';

interface IWarehouses {
  name: string;
  id: number;
}

export class StatusTutorial {
  constructor(
    private status: StatusGroupRes,
    private warehouses: IWarehouses[] | undefined,
  ) {}

  public get description() {
    switch (this.status.type) {
      case 'waiting':
        return this.waitingDescription;
      case 'planned':
        return this.planningDescription;
      case 'warehouse':
        return this.warehousingDescription;
      case 'loaded':
        return this.loadingDescription;
      case 'delivered':
        return this.deliveredDescription;
      default:
        return '';
    }
  }

  private get senderName() {
    const warehouseFrom = findWarehouseById(this.status.fromWarehouseId, this.warehouses);
    return warehouseFrom ? `our ${warehouseFrom.name} warehouse` : 'the sender';
  }

  private get receiverName() {
    const warehouseTo = findWarehouseById(this.status.toWarehouseId, this.warehouses);
    return warehouseTo ? `our ${warehouseTo.name} warehouse` : 'the receiver';
  }

  private get waitingDescription() {
    return 'Your order has been accepted for processing';
  }

  private get planningDescription() {
    return `Your shipment was planned for loading from ${this.senderName} to ${this.receiverName}`;
  }

  private get loadingDescription() {
    return `Your shipment was loaded from ${this.senderName} to ${this.receiverName}`;
  }

  private get warehousingDescription() {
    return `Your cargo has been placed in temporary storage at ${this.receiverName}`;
  }

  private get deliveredDescription() {
    return 'Your shipment was delivered';
  }
}
